<template>
  <div class="info-main">
    <el-form
      class="page-form"
      :model="PersonInfo"
      label-position="left"
    >
      <p class="sub_t">PersonInfo</p>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item prop="FirstGivenName" label="First Given Name">
            {{ PersonInfo.FirstGivenName || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="FirstSurName" label="First Sur Name">
            {{ PersonInfo.FirstSurName || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="Birth" label="Date of Birth">
            {{ PersonInfo.Birth || "--" }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      class="page-form"
      :model="NationalIds"
    >
      <p class="sub_t">NationalIds</p>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item prop="Number" label="Number">
            {{ NationalIds.Number || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="Type" label="Type">
            {{ NationalIds.Type || "--" }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      class="page-form"
      :model="Location"
      label-position="left"
    >
      <p class="sub_t">Location</p>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item prop="BuildingNumber" label="Building Number">
            {{ Location.BuildingNumber || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="BuildingName" label="Building Name">
            {{ Location.BuildingName || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="StreetName" label="Street Name">
            {{ Location.StreetName || "--" }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item prop="County" label="County">
            {{ Location.County || "--" }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    PersonInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    NationalIds: {
      type: [Object],
      default: () => {
        return {};
      }
    },
    Location: {
      type: Object,
      default: () => {
        return {};
      }
    },
    Communication: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {
    };
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped lang="scss">
.info-main {
 padding:0 0.32rem;
}
.sub_t {
  font-size: 0.18rem;
  font-weight: bold;
}
</style>
